<section class="mobile-phone-details">
  <div class="mobile-info-section">
    <app-mobilephone-info
      [isLoadingMobilePhoneOffering]="isLoadingMobilePhoneOffering"
      [isManualRegistration]="isManualRegistration"
      [isMinified]="mobilBytteHelperService.isV2(equipmentUpgradeAgreement)"
      [mobilePhoneVariant]="newMobilePhoneVariant"
    />
    <app-mobilephone-header
      title="Gammel telefon"
      [icon]="IconNames.ice_mobilbytte"
      [image]="image"
      [insuranceName]="insuranceName"
      [insurancePrice]="insurancePrice"
      [mobilePhoneImei]="equipmentUpgradeAgreement.activeImei"
      [mobilePhoneName]="equipmentUpgradeAgreement.phoneModel"
      [ngClass]="[
        newMobileForm.invalid ? 'invalid' : '',
        mobilBytteHelperService.isV2(equipmentUpgradeAgreement) ? '' : 'mobil-bytte-v1',
      ]"
      (click)="newMobileForm.valid && onSelectOldMobile()"
    />
    @if (!equipmentUpgradeAgreement?.insuranceServiceId && mobilBytteHelperService.isV2(equipmentUpgradeAgreement)) {
      <app-ice-alert type="info" [iconName]="IconNames.ice_info">
        <b>Ingen forsikring</b>
        <br />
        Kunden har ikke forsikring på denne avtalen.
        <br />
        Det betyr at mobilen ikke kan byttes inn dersom den er skadet. Eventuelle skader må repareres hos en godkjent
        reparatør før innbytte kan gjennomføres.
      </app-ice-alert>
    }
  </div>
  @if (!isOldMobileSelected) {
    <div class="variant-and-return-wrapper">
      <form [formGroup]="newMobileForm">
        <app-new-mobile-phone-details
          [canSellHardwareWithLogisticsClaim]="canSellHardwareWithLogisticsClaim()"
          [existingProductsAvailableForEquipmentUpgradeUpgrade]="existingProductsAvailableForEquipmentUpgradeUpgrade()"
          [existingVoiceProducts]="existingVoiceProducts()"
          [hasPerformedDetailedCreditCheck]="hasPerformedDetailedCreditCheck()"
          [hasSubscriptionsAvailableForRedemption]="hasSubscriptionsAvailableForRedemption()"
          [isEquipmentUpgradeEnabled]="isEquipmentUpgradeEnabled()"
          [isEquipmentUpgradePreCheckSuccessful]="isEquipmentUpgradePreCheckSuccessful()"
          [isManualRegistration]="isManualRegistration"
          [isMobilBytteBytte]="true"
          [isSubscriptionLimitReached]="isSubscriptionLimitReached()"
          [mobilePhoneGroupVariants]="mobilePhoneGroupVariants"
          [mobilePhoneVariant]="mobilePhoneVariant"
          [selectedExistingSubscriptionId]="selectedExistingSubscriptionId"
          (backToSearch)="backToSearch.emit()"
          (selectionCompleted)="onSelectionCompleted()"
          (setNewMobilePhoneVariant)="onSetNewMobilePhoneVariant($event)"
        />
      </form>
    </div>
  } @else {
    <div class="variant-and-return-wrapper">
      <div>
        <app-old-mobile-phone-details
          [canSellHardwareWithLogisticsClaim]="canSellHardwareWithLogisticsClaim()"
          [customerEmail]="customer.email"
          [equipmentUpgradeAgreement]="equipmentUpgradeAgreement"
          [gradingQuestions]="gradingQuestions"
          (gradingCompleted)="onGradingCompleted($event)"
        />
      </div>
    </div>
  }
</section>
